import { jsx as _jsx } from "preact/jsx-runtime";
import { forwardRef } from 'react';
import clsx from 'clsx';
import getModuleTop from '../../../utils/getModuleTop';
import styles from './Wrapper.module.scss';
const Wrapper = forwardRef(({ className, children, height, top = 0, left = 0, animationName, isVisible, isStatic }, ref) => {
    const wrapperStyles = clsx(styles.wrapper, isVisible && styles.isVisible, !isStatic && styles.isFixed, className);
    const style = {
        '--pf-wrapper-height': height ? `${height}px` : 'auto',
        '--pf-wrapper-top': top ? `${top}px` : `${getModuleTop()}px`,
        '--pf-wrapper-left': isStatic ? `0` : `${left}px`,
        '--pf-wrapper-animation': animationName ? `${animationName}` : 'none',
    };
    return (_jsx("div", Object.assign({ className: wrapperStyles, style: style, ref: ref }, { children: children }), void 0));
});
export default Wrapper;
